import React, { useState } from "react";
import { Layers, FlaskConical, ChevronDown } from "lucide-react";
import { MODULES, LABS } from "@/data/certificationProgramData";

export function CurriculumSection() {
  const [openModule, setOpenModule] = useState(0);
  return (
    <div className="mb-10" data-testid="certification-curriculum-section">
      <h2 className="font-heading text-2xl font-semibold text-white mb-1 flex items-center gap-2"><Layers className="w-5 h-5 text-amber-300" /> 8 weeks. 12 modules. Zero fluff.</h2>
      <p className="text-sm text-slate-400 mb-5">Expand each module to see topics covered.</p>
      <div className="space-y-2" data-testid="certification-modules-list">
        {MODULES.map((m, i) => (
          <div key={i} className="border border-white/10 rounded-xl overflow-hidden" data-testid={`certification-module-${i}`}>
            <button onClick={() => setOpenModule(openModule === i ? -1 : i)} data-testid={`certification-module-toggle-${i}`} className="w-full flex items-center justify-between gap-3 px-4 py-3.5 text-left bg-white/[0.02] hover:bg-white/[0.04] transition-colors">
              <span className="text-sm font-semibold text-white">
                <span className="text-amber-300 font-bold mr-2">Week {m.week}</span> Module {i + 1}: {m.title}
              </span>
              <ChevronDown className={`w-4 h-4 text-slate-400 shrink-0 transition-transform ${openModule === i ? "rotate-180" : ""}`} />
            </button>
            {openModule === i && (
              <div className="px-4 py-3.5 border-t border-white/10" data-testid={`certification-module-topics-${i}`}>
                <ul className="space-y-1.5">
                  {m.topics.map((t, j) => <li key={j} className="text-sm text-slate-400 flex items-start gap-2"><span className="text-amber-400 mt-0.5">•</span> {t}</li>)}
                </ul>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export function LabsSection() {
  return (
    <div className="mb-10" data-testid="certification-labs-section">
      <h2 className="font-heading text-2xl font-semibold text-white mb-1 flex items-center gap-2"><FlaskConical className="w-5 h-5 text-amber-300" /> Practice on every major module.</h2>
      <p className="text-sm text-slate-400 mb-5">Guided lab exercises reinforce each concept before you apply it in a live project.</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-testid="certification-labs-grid">
        {LABS.map((l, i) => (
          <div key={i} className="glass-panel rounded-xl p-5" data-testid={`certification-lab-${i}`}>
            <span className="text-[11px] font-bold text-amber-300">Lab {i + 1}</span>
            <p className="text-sm font-semibold text-white mt-1.5 mb-1.5">{l.title}</p>
            <p className="text-xs text-slate-400 leading-relaxed">{l.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
